<template>
  <Modal :title="$t('global.upgrade-your-free-trial-plan')" @close="close" size="large">
    <template #body>
      <div class="mb-4">{{ $t("global.free-trial-upgrade-keep-previous-data") }}</div>
      <div class="mb-4 d-flex">
        <FormCheckbox name="primary" v-model="keepData" :value="keepData" />
        <div class="ml-2">{{ $t("global.free-trial-upgrade-yes-keep-data") }}</div>
      </div>
      <!-- <div v-if="keepData">
        <div class="mb-2">{{ $t("global.free-trial-upgrade-keep-data-desc-1") }}</div>
        <div class="mb-2">{{ $t("global.free-trial-upgrade-keep-data-desc-2") }}</div>
        <div class="mb-2">{{ $t("global.free-trial-upgrade-keep-data-desc-3") }}</div>
      </div>
      <div v-else></div> -->
    </template>
    <template #footer>
      <Btn @click="close" variant="primaryOutline">{{ $t("global.cancel") }}</Btn>
      <Btn class="ml-2" @click="upgrade" variant="primary">{{ $t("global.upgrade") }}</Btn>
    </template>
  </Modal>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import FormCheckbox from "@/components/display/form/FormCheckbox";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "FreeTrialPlanUpgradeModal",
  props: {
    data: Object,
    validator: (value) => {
      const hasPackage = !!value.package && typeof value.package === "number";
      const hasPlan = !!value.plan && typeof value.plan === "number";
      const hasApp = !!value.app && typeof value.app === "number";

      return hasPackage && hasPlan && hasApp;
    },
  },
  components: {
    Btn,
    Modal,
    FormCheckbox,
  },
  setup(props, { emit, root }) {
    const keepData = ref(true);
    const close = () => emit("close");
    const upgrade = () => {
      const { plan, app } = props.data;
      if (keepData.value) {
        root.$router.push({
          name: "free-trial-upgrade",
          query: { planId: plan.id, appId: app.id },
        });
      } else {
        root.$router.push({ name: "checkout", query: { appId: app.id } });
      }
      emit("close");
    };

    onMounted(() => {
      store.dispatch("packages/getList");
    });

    return {
      close,
      upgrade,
      keepData,
    };
  },
};
</script>
